import { createSelector } from 'reselect';

export const employeesSelector = createSelector(
  (state) => state.employees,
  (employees) => (
    _.orderBy(employees, ['active', 'role', 'name'], ['desc', 'desc', 'asc'])
  )
);
